import { APIClient } from "../helpers/api_helper";
import { ApiResponse } from "../types/api";

const api = new APIClient();

export interface DashboardInsightServiceRow {
  service_id: number | null;
  name: string;
  quantity: number;
  last_paid_at?: string | null;
}

export interface DashboardInsightClientRow {
  client_id: number;
  name: string;
  total_amount_cents: number;
  country_code?: string;
  phone_number?: string;
  last_service_name?: string | null;
}

export interface DashboardInsightSparklineWeek {
  week_index: number;
  from?: string;
  to?: string;
  average_ticket_cents: number | null;
  paid_orders_count: number;
}

export interface DashboardInsightUnitSparkline {
  unit_id: number;
  unit_name: string;
  weeks: DashboardInsightSparklineWeek[];
}

export type DashboardInsightsPeriodDays = 1 | 7 | 30 | 90;

export interface DashboardInsights {
  unit_id: number | null;
  period_days?: number;
  revenue_cents?: number;
  average_ticket_cents?: number | null;
  average_ticket_cents_30d: number | null;
  average_ticket_cents_previous_30d: number | null;
  average_ticket_delta_bps: number | null;
  paid_orders_count?: number;
  paid_orders_count_30d: number;
  appointments_count?: number;
  attendance_rate_bps?: number | null;
  top_services: DashboardInsightServiceRow[];
  top_clients: DashboardInsightClientRow[];
  credits_expiring_30d: number;
  ticket_sparkline_4w?: DashboardInsightSparklineWeek[];
  ticket_sparkline_by_unit?: DashboardInsightUnitSparkline[];
  windows: {
    ticket_days: number;
    services_days: number;
    clients_days: number;
    credits_days: number;
    period_days?: number;
  };
  cached_until: string;
}

export const getDashboardInsights = (
  unitId?: number | null,
  days: DashboardInsightsPeriodDays = 30
): Promise<ApiResponse<DashboardInsights>> =>
  api.get<ApiResponse<DashboardInsights>>("/dashboard/insights", {
    ...(unitId != null ? { unit_id: unitId } : {}),
    days,
  });
